export const ADMIN_DATA_SOURCES_TYPE_FILTER_KEY = "adminDataSourcesTypeFilter";

export function stashAdminDataSourcesTypeFilter(value) {
  try {
    sessionStorage.setItem(ADMIN_DATA_SOURCES_TYPE_FILTER_KEY, value);
  } catch {
    // ignore storage errors
  }
}

export function resolveAdminDataSourcesTypeFilter(initialTypeFilter = "all") {
  let filter = initialTypeFilter;
  if (filter === "automotive" || filter === "vehicle") {
    filter = "vehicle_market";
  }

  try {
    const stored = sessionStorage.getItem(ADMIN_DATA_SOURCES_TYPE_FILTER_KEY);
    if (stored) {
      sessionStorage.removeItem(ADMIN_DATA_SOURCES_TYPE_FILTER_KEY);
      return stored;
    }
  } catch {
    // ignore storage errors
  }

  return filter;
}
